import { useEffect, useState } from "react";

export const useCopyText = () => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyText = (text: string) => {
    navigator.clipboard.writeText(text || "");
    setIsCopied(true);
  };

  useEffect(() => {
    const resetCopyButton = setTimeout(() => {
      if (isCopied) setIsCopied(false);
    }, 3000);

    return () => {
      clearTimeout(resetCopyButton);
    };
  }, [isCopied]);

  return { handleCopyText, isCopied };
};
